import type { CentrixExtractParameters } from "core/entities/CentrixTypes";
import { type UseCentrixApiArg, useCentrixApi } from "./useCentrixApi";

export type PublicShopsFilter =
  CentrixExtractParameters<"/api/shared-entities/shops/public">["query"];

export function usePublicShops({
  filter,
  shouldFetch = true,
  fetchAll = true,
  swrOptions,
}: {
  filter?: PublicShopsFilter;
  shouldFetch?: boolean;
  fetchAll?: boolean;
  swrOptions?: UseCentrixApiArg<"/api/shared-entities/shops/public">["swrOptions"];
}) {
  return useCentrixApi({
    path: "/api/shared-entities/shops/public",
    parameters: { query: filter },
    shouldFetch,
    fetchAll,
    swrOptions,
  });
}
